import React, { useState } from 'react';
import { useMutation, gql } from '@apollo/client';
import { Button, Dialog, EditIcon, toaster } from 'evergreen-ui';
import { AppInputField,InputFieldTitleText} from '../../../../../widget/styledComponents/input_field.style';

const EDIT_DEBT_MUTATION = gql`
  mutation Debt_edit(
    $debtId: ID!
    $title: String!
    $amount: Float!
    $startDate: Date!
    $endDate: Date!
  ) {
    debt_edit(debtId: $debtId, title: $title, amount: $amount, startDate: $startDate, endDate: $endDate) {
      _id
      property
      title
      amount
      status
      paidOn
      paidBy
      paidByType
      startDate
      endDate
      createdAt
    }
  }
`;

const EditDebtButton = ({ debtId, title, amount, startDate, endDate }) => {
  const [isDialogShown, setIsDialogShown] = useState(false);
  const [formData, setFormData] = useState({ title, amount, startDate, endDate });

  const [editDebt, { loading }] = useMutation(EDIT_DEBT_MUTATION, {
    onCompleted: (data) => {
      // toaster.success(`Debt with ID ${data.debt_edit._id} updated successfully.`);
      toaster.success(`Debt updated successfully.`);
      setIsDialogShown(false);
      window.location.reload()
    },
    onError: (err) => {
      toaster.danger(`Failed to update debt: ${err.message}`);
    },
  });

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleEdit = () => {
    const { title, amount, startDate, endDate } = formData;

    if (!title.trim() || !amount || !startDate || !endDate) {
      toaster.warning('All fields are required.');
      return;
    }

    editDebt({
      variables: {
        debtId,
        title,
        amount: parseFloat(amount), // Ensure amount is a number
        startDate,
        endDate,
      },
    });
  };

  return (
    <>
      <Button
        appearance="primary"
        onClick={() => setIsDialogShown(true)}
      >
        <EditIcon/>
      </Button>
      <Dialog
        isShown={isDialogShown}
        title="Edit Debt"
        onCloseComplete={() => setIsDialogShown(false)}
        confirmLabel={loading ? 'Updating...' : 'Update'}
        onConfirm={handleEdit}
        isConfirmLoading={loading}
      >
        <InputFieldTitleText>
         Title
        </InputFieldTitleText>
        <AppInputField
          label="Title"
          value={formData.title}
          onChange={(e) => handleChange('title', e.target.value)}
          required
        />
        <InputFieldTitleText>
        Amount
        </InputFieldTitleText>
        <AppInputField
          label="Amount"
          type="number"
          value={formData.amount}
          onChange={(e) => handleChange('amount', e.target.value)}
          required
        />
        <InputFieldTitleText>
        Start Date
        </InputFieldTitleText>
        <AppInputField
          label="Start Date"
          type="date"
          value={formData.startDate}
          onChange={(e) => handleChange('startDate', e.target.value)}
          required
        />
        <InputFieldTitleText>
        End Date
        </InputFieldTitleText>
        <AppInputField
          label="End Date"
          type="date"
          value={formData.endDate}
          onChange={(e) => handleChange('endDate', e.target.value)}
          required
        />
      </Dialog>
    </>
  );
};

export default EditDebtButton;
